import { c as _c } from "react/compiler-runtime";
import { usePreservedSearch } from "@hooks/use-preserved-search";
import { forwardRef } from "react";
import { NavLink } from "react-router-dom";
/**
 * A custom NavLink component that preserves some query parameters when navigating to a new route.
 * @see PRESERVED_QUERY_PARAMS
 */
export const PreservingNavLink = forwardRef((t0, _ref) => {
  const $ = _c(6);
  let rest;
  let to;
  if ($[0] !== t0) {
    ({
      to,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = to;
  } else {
    rest = $[1];
    to = $[2];
  }
  const toWithSearch = usePreservedSearch(to);
  let t1;
  if ($[3] !== rest || $[4] !== toWithSearch) {
    t1 = <NavLink to={toWithSearch} draggable={false} {...rest} />;
    $[3] = rest;
    $[4] = toWithSearch;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});